import { AssetClassCreatedEvent, } from '../event/asset-class-created.event';
const assetClassCreatedProjections = {
    [AssetClassCreatedEvent.name]: (event, state) => ({
        ...state,
        ...event.getPayload(),
    }),
};
export default assetClassCreatedProjections;
//# sourceMappingURL=asset-class-created.projection.js.map